module.exports = "/_next/static/images/australia-line-d643a7c79a8d35a908a038b41d0e02cb.svg";